var exports = {
  "Gf": "FriendsListSection.module__sectionTitle___b3dRaG",
  "f5": "FriendsListSection.module__sectionContent___b3dRaG",
  "v2": "FriendsListSection.module__sectionContentWithMargin___b3dRaG",
};

module.exports = exports;
